export default __webpack_public_path__ + "static/media/office2-afterB-1920w.f6fd7123.avif";